"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var recaptcha_loader_service_1 = require("./recaptcha-loader.service");
var nextId = 0;
var RecaptchaComponent = (function () {
    function RecaptchaComponent(loader, zone) {
        this.loader = loader;
        this.zone = zone;
        this.id = "ngrecaptcha-" + nextId++;
        this.resolved = new core_1.EventEmitter();
    }
    RecaptchaComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.subscription = this.loader.ready.subscribe(function (grecaptcha) {
            if (grecaptcha != null) {
                _this.grecaptcha = grecaptcha;
                _this.renderRecaptcha();
            }
        });
    };
    RecaptchaComponent.prototype.ngOnDestroy = function () {
        // reset the captcha to ensure it does not leave anything behind
        // after the component is no longer needed
        if (this.widget != null) {
            this.grecaptcha.reset(this.widget);
        }
        this.subscription.unsubscribe();
    };
    /**
     * Executes the invisible recaptcha.
     * Does nothing if component's size is not set to "invisible".
     */
    RecaptchaComponent.prototype.execute = function () {
        if (this.size !== 'invisible') {
            return;
        }
        if (this.widget != null) {
            // tslint:disable-next-line:no-any
            this.grecaptcha.execute(this.widget);
        }
    };
    RecaptchaComponent.prototype.reset = function () {
        if (this.widget != null) {
            if (this.grecaptcha.getResponse(this.widget)) {
                // Only emit an event in case if something would actually change.
                // That way we do not trigger "touching" of the control if someone does a "reset"
                // on a non-resolved captcha.
                this.resolved.emit(null);
            }
            this.grecaptcha.reset(this.widget);
        }
    };
    /** @internal */
    RecaptchaComponent.prototype.expired = function () {
        this.resolved.emit(null);
    };
    /** @internal */
    RecaptchaComponent.prototype.captchaReponseCallback = function (response) {
        this.resolved.emit(response);
    };
    /** @internal */
    RecaptchaComponent.prototype.renderRecaptcha = function () {
        var _this = this;
        this.widget = this.grecaptcha.render(this.id, {
            callback: function (response) {
                _this.zone.run(function () { return _this.captchaReponseCallback(response); });
            },
            'expired-callback': function () {
                _this.zone.run(function () { return _this.expired(); });
            },
            sitekey: this.siteKey,
            // tslint:disable-next-line:no-any
            size: this.size,
            tabindex: this.tabIndex,
            theme: this.theme,
            type: this.type,
        });
    };
    return RecaptchaComponent;
}());
__decorate([
    core_1.Input(),
    core_1.HostBinding('attr.id'),
    __metadata("design:type", Object)
], RecaptchaComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RecaptchaComponent.prototype, "siteKey", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RecaptchaComponent.prototype, "theme", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RecaptchaComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RecaptchaComponent.prototype, "size", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], RecaptchaComponent.prototype, "tabIndex", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], RecaptchaComponent.prototype, "resolved", void 0);
RecaptchaComponent = __decorate([
    core_1.Component({
        exportAs: 'reCaptcha',
        selector: 'recaptcha',
        template: "",
    }),
    __metadata("design:paramtypes", [recaptcha_loader_service_1.RecaptchaLoaderService,
        core_1.NgZone])
], RecaptchaComponent);
exports.RecaptchaComponent = RecaptchaComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-recaptcha/recaptcha/recaptcha.component.js
// module id = 262
// module chunks = 0